// extracted by css-extract-rspack-plugin
export default {"LayoutContainer":"LayoutContainer-PKJp0h","layoutContainer":"LayoutContainer-PKJp0h"};